import Page from './page';
import ProductGallery from '../components/product/product-gallery';
import PageHelper from '../helpers/page-helper';
import FileDocumentData from '../model/file-document-data';
import ProductData from '../model/product-data';
import Table from '../components/shared/table';
import VehicleLine from '../model/vehicle-line-data';
import MessageHelper from '../helpers/message-helper';
import HTMLTemplateHelper from "../helpers/html-template-helper";
import MatchingTires from '../components/product/matching-tires';

const selectors = {
  container: '.js-productDetailsDocuments',
  vehicleLinesContainer: '.js-productDetailsVehicleLines',
  vehicleLinesTableSelector: '.js-vehicle-lines-table',
  filesTab: '.js-filesTab',
  quantitySelector: '.js-qty-selector-input',
  bomQuantitySelector: '.js-bomQty',
  safetyDataSheetSelector: '.js-safetyDataSheet',
  documentLoadingTemplateSelector: '.js-documentLoadingModal',
};

const HTTP_STATUS_NO_CONTENT = 204;

export default class ProductDetailsPage extends Page {
  private readonly container: JQuery;
  private readonly vehicleLinesContainer: JQuery;
  private readonly vehicleLinesTable: Table;
  private readonly vehicleLinesTableColumnDefinitions: DataTables.ColumnDefsSettings[] = [{
    targets: 0,
    data: 'brand',
  }, {
    targets: 1,
    data: 'type',
  }, {
    targets: 2,
    data: 'code',
  }, {
    targets: 3,
    data: 'startYear',
  },
    // {
  //   targets: 4,
  //   className: 'text-align-center',
  //   data: (data: VehicleLine): string => {
  //     if (!data.axis) {
  //       return '';
  //     }
  //     return MessageHelper.getMessage('eparts.vehicle.line.axis.' + data.axis);
  //   },
  // }, {
  //   targets: 5,
  //   className: 'text-align-center',
  //   data: (data: VehicleLine): string => {
  //     if (!data.dimension) {
  //       return '';
  //     }
  //     switch (data.dimension) {
  //       case "0":
  //         return '<i class="fas fa-check mr-5"/><i class="fas fa-check mr-5"/i>';
  //       case "1":
  //         return '<i class="fas fa-check mr-5"/i>';
  //       case "2":
  //         return '<i class="fas fa-times"/i>';
  //       default:
  //         return '';
  //     }
  //     },
  // },{
  //   targets: 6,
  //   className: 'text-align-center',
  //   data: (data: VehicleLine): string => {
  //     if (!data.asa) {
  //       return '';
  //     }
  //     return HTMLTemplateHelper.createLinkButton({
  //       buttonClass: '-clear -compact',
  //       href: `${window.ACC.config.encodedContextPath}/orders/deliverynote/print?token=${data.asa}`,
  //       text: MessageHelper.getMessage('common.print'),
  //       textClass: 'sr-only',
  //       icon: 'fas fa-file-download',
  //     }).outerHTML;
  //   },
  // }
  ];

  constructor(private body: HTMLBodyElement) {
    super();
    this.container = $(selectors.container);
    this.vehicleLinesContainer = $(selectors.vehicleLinesContainer);
    this.vehicleLinesTable = new Table($(selectors.vehicleLinesTableSelector), this.vehicleLinesTableColumnDefinitions);

    ProductGallery.initAll();
    MatchingTires.initAll();

    this.bindVariantSelector();
    this.bindProductVehicleLines();
    this.bindProductDocuments();
    this.bindBomQuantity();
    this.bindDownloadSafetyDataSheet();
  }

  private bindVariantSelector(): void {
    const variantSelector = this.body.querySelector<HTMLSelectElement>('.js-productVariant');
    const quantitySelector = this.body.querySelector<HTMLInputElement>('.js-qty-selector-input') as HTMLInputElement;

    if (variantSelector) {
      variantSelector.addEventListener('change', () => {
        const productCode = variantSelector.value ?? '';
        PageHelper.showLoadingIndicator();
        window.location.href = `${window.ACC.config.encodedContextPath}/p/${productCode}?qty=${quantitySelector.value}`;
      });
    }
  }

  private bindProductDocuments() {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    ProductDetailsPage.getProductDocuments(this.container.data('product-code'))
      .done((data: FileDocumentData[]) => data.forEach((document): void => {
        if (data.length) {
          $(selectors.filesTab).removeClass('d-none');
          this.container.append(
            $(`<li>
              <a href="${window.ACC.config.encodedContextPath}/product/document/download?token=${document.fileDownloadJwt}"><i class="fas fa-download mr-5"></i>${document.id}</a>
             </li>`),
          );
        }
      }))
      .fail((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  }

  private bindProductVehicleLines() {
    if (!this.vehicleLinesContainer.length) {
      return;
    }
    const productCode = this.vehicleLinesContainer.data('product-code');
    if (!productCode) {
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    ProductDetailsPage.getProductVehicleLines(productCode)
      .done((data: ProductData) => {
        if (!data?.vehicleLines?.length) return;
        this.vehicleLinesTable.setRows(data.vehicleLines);
      })
      .fail((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  }

  private bindBomQuantity(): void {
    $(selectors.quantitySelector).on('change', (event) => {
      $(selectors.bomQuantitySelector).each((index, element) => {
        const bundleQuantity = Number((event.target as HTMLInputElement).value ?? 1);
        const baseQuantity = Number(element.dataset.qty ?? 1);
        // eslint-disable-next-line no-param-reassign
        element.textContent = `${baseQuantity * bundleQuantity}`;
      });
    });
  }

  private bindDownloadSafetyDataSheet(): void {
    const downloadLink = this.body.querySelector<HTMLAnchorElement>(selectors.safetyDataSheetSelector);
    if (!downloadLink) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    downloadLink.addEventListener('click', async (event) => {
      event.preventDefault();
      const url = downloadLink.href;
      await this.generateAndDownload(url, `${downloadLink.dataset.id ?? 'datasheet'}.pdf`);
    });
  }

  private static getProductDocuments(productCode: string): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/documents/product/${productCode}`,
      method: 'GET',
    });
  }

  private static getProductVehicleLines(productCode: string): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/product/vehiclelines/${productCode}`,
      method: 'GET',
    });
  }

  private setRows(data: VehicleLine[] | undefined): void {
    if (Array.isArray(data)) {
      this.vehicleLinesTable.setRows(data);
    }
  }

  private async generateAndDownload(apiUrl: string, fallbackFilename: string): Promise<void> {
    const popup = this.showDocumentGeneratingPopup();

    try {
      const response = await fetch(apiUrl);

      if (response.status === HTTP_STATUS_NO_CONTENT) {
        window.NotificationHelper.showInfo(MessageHelper.getMessage('common.sap.file.download.no.data.info'));
        return;
      }

      if (!response.ok) {
        throw new Error(`Request failed: ${response.statusText}`);
      }

      const contentDisposition = response.headers.get('Content-Disposition');
      const filename = contentDisposition
        ? contentDisposition.split('filename=')[1]?.replace(/['"]/g, '').trim()
        : fallbackFilename;

      const blob = await response.blob();
      this.triggerDownload(blob, filename ?? fallbackFilename);
    } catch (err) {
      console.error('Document generation failed:', err);
      window.NotificationHelper.showError(MessageHelper.getMessage('common.sap.file.download.error'));
    } finally {
      popup.remove();
    }
  }

  private showDocumentGeneratingPopup(): HTMLElement {
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed; inset: 0;
      display: flex; 
      align-items: center; 
      justify-content: center;
      background: rgba(0,0,0,0.4);
      z-index: 9999;
    `;

    const box = document.createElement('div');
    box.style.cssText = `
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      background: white; 
      padding: 60px;
      border-radius: 8px; 
      text-align: center;
      font-size: 18px;
    `;

    box.innerHTML = this.body.querySelector(selectors.documentLoadingTemplateSelector)?.innerHTML ?? 'Generating document...';

    overlay.appendChild(box);
    document.body.appendChild(overlay);
    return overlay;
  }

  private triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }
}
